import React, { ComponentProps } from "react";
import { cls } from "@wss/cls";
import {
  baseTileStyling,
  baseTileBorderStyling,
  baseTileHoverStyling,
  selectedTileBorderStyling,
} from "../../styles/Tiles.styles";

interface TileContainerProps {
  children: React.ReactNode;
  link: string;
  isPlusEligible: boolean;
  isCurrentlySelected: boolean;
}

const TileContainer = ({
  children,
  isCurrentlySelected,
  isPlusEligible,
  link,
  className,
  ...rest
}: TileContainerProps & ComponentProps<"a">) => {
  return (
    <a
      href={link}
      aria-current={isCurrentlySelected ? "page" : "false"}
      className={cls(
        "flex flex-col h-full relative overflow-hidden",
        "focus-visible:before:border-2",
        "focus-visible:before:border-[#005FCC]",
        baseTileStyling,
        baseTileHoverStyling,
        isCurrentlySelected ? selectedTileBorderStyling : baseTileBorderStyling,
        className,
      )}
      data-testid={
        isPlusEligible ? "webplus-quantity-flag" : "plus-ineligible-quantity"
      }
      {...rest}
    >
      {children}
    </a>
  );
};

export default TileContainer;
